<div class="content-layout" [brightsideWebFb]="{event_name: 'loan_partner'}">
  <bw-action-article-legacy>
    <div header-actions>
      <ui-nav-exit-back
        [trackingDetail]="{ event_name: 'loans_intro' }"
        [skipActionEmit]="false"
        (exitActionHandler)="goHome()"
      ></ui-nav-exit-back>
    </div>
    <div pre-title>
      <div class="partner-logo" [style.background-image]="'url(../assets/' + img + ')'"></div>
    </div>
    <div content-section>
      <div class="mb-sm">
        <typography-legacy
          class="mb-xs"
          text-xsmall-regular
          color="var(--secondary-text)">
          {{ 'LOAN_PARTNER_TITLE' | translate }}
        </typography-legacy>
        <typography-legacy
          text-large-semibold
          color="var(--primary-text)">
          {{ loanPartner.displayName }}
        </typography-legacy>
      </div>
      <typography-legacy
        class="mb-sm"
        text-small-regular
        color="var(--secondary-text)">
        {{ 'LOAN_PARTNER_DESC' | translate:{partnerName:loanPartner.displayName} }}
      </typography-legacy>
      <typography-legacy
        class="mb-sm"
        text-small-semibold>
        {{ 'LOAN_PARTNER_BODY_HEADER' | translate }}
      </typography-legacy>
      <div class="flex-row mb-xs">
        <bw-icon-legacy [iconName]="'arrow_right'" class="mr-sm"></bw-icon-legacy>
        <typography-legacy text-xsmall-regular>{{ 'LOAN_PARTNER_BODY_ITEM_1' | translate }}</typography-legacy>
      </div>
      <div class="flex-row mb-xs">
        <bw-icon-legacy [iconName]="'arrow_right'" class="mr-sm"></bw-icon-legacy>
        <typography-legacy text-xsmall-regular>{{ 'LOAN_PARTNER_BODY_ITEM_2' | translate }}</typography-legacy>
      </div>
      <div class="flex-row mb-xs">
        <bw-icon-legacy [iconName]="'arrow_right'" class="mr-sm"></bw-icon-legacy>
        <typography-legacy text-xsmall-regular>{{ 'LOAN_PARTNER_BODY_ITEM_3' | translate }}</typography-legacy>
      </div>
      <div class="flex-row mb-xs">
        <bw-icon-legacy [iconName]="'arrow_right'" class="mr-sm"></bw-icon-legacy>
        <typography-legacy text-xsmall-regular>{{ 'LOAN_PARTNER_BODY_ITEM_4' | translate }}</typography-legacy>
      </div>


    </div>
    <div footer-actions>
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'loan_partner'}"
        (click)="routeUser();">
        {{ 'LOAN_PARTNER_PRIMARY_CTA' | translate:{partnerName:loanPartner.displayName} }}
      </button>
    </div>

  </bw-action-article-legacy>
</div>
